// Polyfills
import 'core-js/stable';
import 'regenerator-runtime/runtime';

import register from './register';

// App
import './lib/field-survey';
import './lib/sequences/signup';
import './lib/sequences/blackouts';
import './lib/sequences/not-serviceable';
import './lib/sequences/wait-list';
import './lib/sequences/unknown';
import './lib/sequences/d2c_eligible';
import './lib/sequences/preorder';
import './lib/check-availability';
import 'handlebars/runtime';
import './lib/acumen/index';


// Load modules if present on page
document.addEventListener( 'DOMContentLoaded', () => {
  const slice = Array.prototype.slice;
  const elems = document.querySelectorAll('[data-module]');

  slice.call( elems ).forEach( elem => {
    const name = elem.getAttribute('data-module');
    const mod = register.registry[ name ];
    if ( typeof mod === 'function' ) {
      mod();
      delete register.registry[ name ];
    }
  });
});
